// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2ultE","modalForm":"UpgradeEpcsModal_modalForm__3OgGG","modalFooter":"UpgradeEpcsModal_modalFooter__xkY5j"};